module.exports = __webpack_public_path__ + "img/centerIonc3.327a3f20.png";